export interface SingleNumericOperationPayload {
  number: number;
}

export interface BetweenNumericOperationPayload {
  start: number;
  end: number;
}

export type NumericOperationPayload = SingleNumericOperationPayload | BetweenNumericOperationPayload;
